import { EntityListView } from '../components/EntityListView';

export function EmpresasView({ empresas, loading, onAdd, onEdit, onDelete }) {
  return (
    <EntityListView
      title="Empresas"
      subtitle="Cadastro das empresas emissoras de notas fiscais"
      items={empresas}
      loading={loading}
      addLabel="Nova empresa"
      emptyText="Nenhuma empresa cadastrada"
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
      columns={[
        { key: 'nome_fantasia', label: 'Nome', render: (e) => (
          <div>
            <div style={{ fontWeight: 600 }}>{e.nome_fantasia || e.razao_social}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{e.razao_social}</div>
          </div>
        )},
        { key: 'cnpj', label: 'CNPJ', render: (e) =>
          <span className="font-mono" style={{ fontSize: 12 }}>{e.cnpj}</span> },
        { key: 'cidade', label: 'Cidade/UF', render: (e) => `${e.cidade || '—'}/${e.uf || '—'}` },
        { key: 'email', label: 'Contato', render: (e) => (
          <div>
            <div style={{ fontSize: 12.5 }}>{e.email || '—'}</div>
            <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>{e.telefone}</div>
          </div>
        )},
      ]}
    />
  );
}
